import { z, isoZ } from 'my-zod'
import { enumOptionsToObject } from '../../internal'

export const CustomerOrderOriginOptions = [
  'PolarisAdventuresASR',
  'AdventuresSitePolarisBranded',
  'AdventuresSiteWhiteLabel',
  'OutfitterDirect'
] as const
export const CustomerOrderOrigins = enumOptionsToObject(CustomerOrderOriginOptions)

export const CustomerOrderBookingMethodOptions = ['adv', 'advWhiteLabel', 'outfitter', 'select', 'viator'] as const
export type CustomerOrderBookingMethod = (typeof CustomerOrderBookingMethodOptions)[number]

export const customerOrderSystemVersionOptions = ['1', '2', '3'] as const
export type CustomerOrderSystemVersion = (typeof customerOrderSystemVersionOptions)[number]

export const CURRENT_SYSTEM_VERSION: CustomerOrderSystemVersion = '3'

if (CURRENT_SYSTEM_VERSION !== customerOrderSystemVersionOptions[customerOrderSystemVersionOptions.length - 1]) {
  throw new Error('Current system version must be last')
}

export const customerOrdersModel = z.object({
  id: z.string().uuid(),
  shortId: z.string().min(1),
  customerId: z.string().uuid(),
  outfitterId: z.number(),
  systemVersion: z.enum(customerOrderSystemVersionOptions),
  feeAgreementVersionId: z.number(),
  taxConfigurationVersionId: z.number(),

  utm_medium: z.string().nullable(),
  utm_source: z.string().nullish(),
  utm_campaign: z.string().nullish(),
  bookingMethod: z.enum(CustomerOrderBookingMethodOptions),
  affiliateId: z.string().nullable(),
  viatorBookingReference: z.string().nullable(),

  // TODO: this field should be renamed to something like "accessSessionId"
  // as field is fulfilled not only by customer session id
  // but also when order is submitted by outfitter (to provide proper reservation url access)
  creatingCustomerSessionId: z.string().nullable(),

  createdDate: isoZ.instant(),
  lastModifiedDate: isoZ.instant()
})

export type customerOrdersModel = z.infer<typeof customerOrdersModel>
